import React, { memo } from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

const DeleteAllIcon = ({ className, width, height, color }) => {
  return (
    <SvgIcon className={className} width={width} height={height} viewBox="0 0 24 24" fill="none" color={color}>
      <path
        d="M10.5 22.1871L16 16.975C17.6833 16.8417 19.1042 16.1583 20.2625 14.925C21.4208 13.6917 22 12.2167 22 10.5C22 8.68333 21.3708 7.14583 20.1125 5.8875C18.8542 4.62917 17.3167 4 15.5 4H14.825L16.4 2.4L15 1L11 5L15 9L16.4 7.6L14.825 6H15.5C16.75 6 17.8125 6.4375 18.6875 7.3125C19.5625 8.1875 20 9.25 20 10.5C20 11.75 19.5625 12.8125 18.6875 13.6875C17.8125 14.5625 16.75 15 15.5 15H14.5L12 17.6972V15L8.5 15C7.25 15 6.1875 14.5625 5.3125 13.6875C4.4375 12.8125 4 11.75 4 10.5C4 9.25 4.4375 8.1875 5.3125 7.3125C6.1875 6.4375 7.25 6 8.5 6H9L9 4H8.5C6.68333 4 5.14583 4.62917 3.8875 5.8875C2.62917 7.14583 2 8.68333 2 10.5C2 12.3167 2.62917 13.8542 3.8875 15.1125C5.14583 16.3708 6.68333 17 8.5 17H10.5L10.5 22.1871Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
DeleteAllIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,

  color: PropTypes.string,
};
DeleteAllIcon.defaultProps = {
  width: 24,
  height: 24,
};

export default memo(DeleteAllIcon);
